import { Type } from '@angular/core';

export interface ComponentWithSelector {
    selector: string;
    component: Type<any>;
}
export class DynamicHtmlOptions {
    components: Array<ComponentWithSelector>;
}